export const DEFAULT_THEME_PALETTE_NAME = "dark"
